var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard } from 'swiper/modules';
import 'swiper/css';
import OrganizationDeveloperPlanCard from './OrganizationDeveloperPlanCard';
import { CarouselIcon, CarouselIconWrapper } from './styles';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { useWindowDimensions } from '../../utils/hooks/dimensions';
var CarouselMonthly = function (_a) {
    var developerPlans = _a.developerPlans, devPlanStatus = _a.devPlanStatus, onSubscribeButtonClick = _a.onSubscribeButtonClick, loading = _a.loading;
    var _b = useState(1), show = _b[0], setShow = _b[1];
    var _c = useState(true), isBeginning = _c[0], setIsBeginning = _c[1];
    var _d = useState(false), isEnd = _d[0], setIsEnd = _d[1];
    var width = useWindowDimensions().width;
    var swiperRef = useRef(null);
    width < 860
        ? show !== 1 && setShow(1)
        : width < 1010
            ? show !== 1.5 && setShow(1.5)
            : width < 1160
                ? show !== 2 && setShow(2)
                : width < 1310
                    ? show !== 2.5 && setShow(2.5)
                    : width < 1520
                        ? show !== 3 && setShow(3)
                        : width < 1610
                            ? show !== 3.5 && setShow(3.5)
                            : width < 1760
                                ? show !== 4 && setShow(4)
                                : width < 1910
                                    ? show !== 4.5 && setShow(4.5)
                                    : width < 2060
                                        ? show !== 5 && setShow(5)
                                        : width < 2210
                                            ? show !== 5.5 && setShow(5.5)
                                            : width < 2360
                                                ? show !== 6 && setShow(6)
                                                : width < 2510
                                                    ? show !== 6.5 && setShow(6.5)
                                                    : width < 2660
                                                        ? show !== 7 && setShow(7)
                                                        : show !== 8 && setShow(8);
    if (!developerPlans || developerPlans.length === 0) {
        return (_jsx("div", __assign({ style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                width: width - 300,
                padding: '48px 24px',
                color: '#888',
                fontSize: '16px',
            } }, { children: "No developer plans available to select." })));
    }
    return (_jsxs("div", __assign({ style: { display: 'flex', alignItems: 'center', width: width - 300 } }, { children: [_jsx(CarouselIconWrapper, __assign({ onClick: function () { var _a; return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slidePrev(); }, style: { visibility: isBeginning ? 'hidden' : 'visible' } }, { children: _jsx(CarouselIcon, { icon: faChevronLeft }) })), _jsx(Swiper, __assign({ modules: [Keyboard], slidesPerView: 3, slidesPerGroup: 1, keyboard: { enabled: true }, loop: false, onSwiper: function (swiper) {
                    swiperRef.current = swiper;
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                }, onSlideChange: function (swiper) {
                    setIsBeginning(swiper.isBeginning);
                    setIsEnd(swiper.isEnd);
                }, style: { flex: 1 } }, { children: developerPlans.map(function (plan) { return (_jsx(SwiperSlide, __assign({ style: { display: 'flex', justifyContent: 'center' } }, { children: _jsx(OrganizationDeveloperPlanCard, { data: plan, devPlanStatus: devPlanStatus, onSubscribeButtonClick: onSubscribeButtonClick, loading: loading }) }), plan.id)); }) })), _jsx(CarouselIconWrapper, __assign({ onClick: function () { var _a; return (_a = swiperRef.current) === null || _a === void 0 ? void 0 : _a.slideNext(); }, style: { visibility: isEnd ? 'hidden' : 'visible' } }, { children: _jsx(CarouselIcon, { icon: faChevronRight }) }))] })));
};
export default CarouselMonthly;
